module.exports = __webpack_public_path__ + "img/redeems_banner.560216fe.png";